// noinspection EqualityComparisonWithCoercionJS

import * as React from "react";
import { useEffect } from "react";
import * as PropTypes from "prop-types";
import { IconButton, SpinButton, Stack } from "@fluentui/react";
import { NumericMoneyFormat } from "../Utilities/MoneyFormat";
import { isNumber } from "chart.js/helpers";

function NetGrossPicker({net, setNet, gross, setGross, vat, setVat, maxNet, hideVat = false, prefix = ''}) {

    useEffect(() => {
        if (vat != 0) {
            if (net == 0 && gross != 0) {
                _calculateNetValue(gross);
            } else if (gross == 0 && net != 0) {
                _calculateGrossValue(net);
            }
        }
    }, [net, gross, vat]);
    const _calculateNetValue = (newGross) => {
        let netValue = parseFloat(newGross);
        if (vat != 0) {
            netValue = parseFloat(newGross) * 100 / (100 + parseInt(vat));
        }
        setNet(NumericMoneyFormat(netValue));
    }
    const suffix = ' zł';
    const _calculateGrossValue = (newNet) => {
        let grossValue = parseFloat(newNet);
        if (vat != 0) {
            grossValue = (parseFloat(newNet) * (100 + parseInt(vat))) / 100;
        }
        setGross(NumericMoneyFormat(grossValue));
    }

    useEffect(() => {
        if(net !== "" && net !== null && maxNet !== null) {
            if(parseFloat(net) > maxNet) {
                setNet(maxNet)
            } else if (parseFloat(net) < 0) {
                setNet(0)
            }
        }

    }, [net, maxNet]);

    const getNumericPart = (value) => {
        const valueRegex = /^(\d+(\.,\d+)?).*/;
        if (valueRegex.test(value)) {
            const numericValue = Number(value.replace(valueRegex, '$1').replace(',', '.'));
            return isNaN(numericValue) ? undefined : numericValue;
        }
        return undefined;
    };


    /**
     * Clamp the value within the valid range (or return nothing to keep the previous value
     * if there's not valid numeric input)
     */
    const onValidate = (value, event) => {
        let numericValue = getNumericPart(value);
        if (numericValue !== undefined) {
            return String(numericValue).replace(',', '.');
        }
    };

    return (<>
        <Stack horizontal verticalAlign={"end"}>
            <SpinButton
                label={prefix + "Netto"}
                labelPosition={"top"}
                step={0.01}
                incrementButtonAriaLabel={"+1"}
                decrementButtonAriaLabel={"-1"}
                value={net}
                onValidate={onValidate}
                onChange={(e, newValue) => {setNet(e.target.value?.replace(',', '.') || newValue || ""); if (vat != 0) {_calculateGrossValue(e.target.value);}}}
            />
            <IconButton iconProps={{ iconName: "Calculator" }} onClick={() => _calculateNetValue(gross)} />
        </Stack>
        {!hideVat && <SpinButton
            label={"VAT"}
            labelPosition={"top"}
            step={1}
            min={0}
            max={100}
            incrementButtonAriaLabel={"+1"}
            decrementButtonAriaLabel={"-1"}
            value={vat}
            onChange={(e) => setVat(e.target.value || "")}
        />}
        <Stack horizontal verticalAlign={"end"}>
            <SpinButton
                label={prefix + "Brutto"}
                labelPosition={"top"}
                step={0.01}
                incrementButtonAriaLabel={"+1"}
                decrementButtonAriaLabel={"-1"}
                value={gross}
                onChange={(e, newValue) => {setGross(e.target.value?.replace(',', '.') || newValue || ""); if (vat != 0) {_calculateNetValue(e.target.value)}}}
            />
            <IconButton iconProps={{ iconName: "Calculator" }} onClick={() => _calculateGrossValue(net)}></IconButton>
        </Stack>
    </>);
}

NetGrossPicker.propTypes = {
    net: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    setNet: PropTypes.func,
    gross: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    setGross: PropTypes.func,
    vat: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    setVat: PropTypes.func
};

export default NetGrossPicker;